/**
 * @ngInject
 */

function factbox () {


	function link ($scope, $elem, $attrs) {

		var handle, factboxElement;

		function onHandleClick (event) {
			factboxElement.classList.toggle('open');
			TweenMax.to(window, 0.55, {scrollTo:{y:factboxElement.offsetTop}});
		}
		
		factboxElement = $elem[0];
		handle = document.createElement('div');
		handle.classList.add('factbox-handle');
		handle.addEventListener('click', onHandleClick);

		factboxElement.appendChild(handle);
	}


	return {
		restrict : 'C',
		link : link
	}
}